import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

import { firebaseConfig } from './config';

const app = initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore();
export const functions = getFunctions(undefined, 'europe-west3');
export const analytics = getAnalytics(app);
export const messaging = getMessaging(app);

export const requestPermissionAndGetMessagingToken = async () => {
    try {
        await Notification.requestPermission();
        await getToken(messaging);
    } catch (error) {
        console.log('An error occurred while retrieving token. ', error);
    }
};

export const onMessageListener = () =>
    new Promise(resolve => {
        onMessage(messaging, payload => {
            resolve(payload);
        });
    });

// eslint-disable-next-line max-len
export const BASE_CLOUD_FUNCTION_URL = `https://${firebaseConfig.locationId}-${firebaseConfig.projectId}.cloudfunctions.net`;
